import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {

  }
}))

export default useStyles
